import { Hotkey, mod } from '../lib/hotkeys';

type HotkeyAlias =
  | 'heading'
  | 'inlineLink'
  | 'bold'
  | 'italic'
  | 'underlined'
  | 'strikethrough'
  | 'inlineCode'
  | 'fontColour';

export const hotkeys: { [key in HotkeyAlias]: Hotkey[] } = {
  heading: [
    {
      modifiers: [mod.meta, mod.shift],
      key: ',',
    },
    {
      modifiers: [mod.meta, mod.shift],
      key: '.',
    },
  ],
  fontColour: [
    {
      modifiers: [mod.meta, mod.shift],
      key: 'K',
    },
  ],
  inlineLink: [
    {
      modifiers: [mod.meta],
      key: 'K',
    },
  ],
  bold: [
    {
      modifiers: [mod.meta],
      key: 'B',
    },
  ],
  italic: [
    {
      modifiers: [mod.meta],
      key: 'I',
    },
  ],
  underlined: [
    {
      modifiers: [mod.meta],
      key: 'U',
    },
  ],
  strikethrough: [
    {
      modifiers: [mod.meta, mod.shift],
      key: 'X',
    },
  ],
  inlineCode: [
    {
      modifiers: [mod.meta, mod.shift],
      key: 'E',
    },
  ],
};
